import { Box } from "@mui/material";
import { useContext, useState } from "react";
import AuthContext from "../../CONTEXT/AuthProvider";
import "./topbar.css";

const Topbar = () => {
  const { auth } = useContext(AuthContext);
  const subscribername = auth.subscriberName;
  const [isHovered, setIsHovered] = useState(false);

  const firstname = auth.firstName;
  const lastname = auth.lastName;
  const fullname = firstname + " " + lastname;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={2}
      backgroundColor="#ffffff"
    >
      {/* SEARCH BAR */}
      <Box display="flex"></Box>

      {/* ICONS */}
      <Box display="flex">
        {subscribername === "BANK OF TANZANIA" ? (
          <h6 className="BOTheading">DISPUTES MANAGEMENT</h6>
        ) : (
          <h6 className="heading">CREDITINFO DISPUTES MANAGEMENT</h6>
        )}
      </Box>

      <Box display="flex">
        <div
          className="user-image-container"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <img
            src="/images/user.png"
            style={{ width: "32px", height: "32px", cursor: "pointer" }}
            alt="logo"
          />
          {isHovered && (
            <div className="tooltip">
              <p>{fullname}</p>
              <p>{auth.subscriberName}</p>
            </div>
          )}
        </div>
      </Box>
    </Box>
  );
};

export default Topbar;
